import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claimsGroups/${COMMON_QUERY_PARAMS.CLAIM_GROUP_ID}/invoices`;

interface CreateInvoiceForClaimGroupCommandArgs {
  claimGroupId: string;
}

const createInvoiceForClaimGroupCommand = async ({
  claimGroupId,
}: CreateInvoiceForClaimGroupCommandArgs): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.CLAIM_GROUP_ID,
      claimGroupId,
    );

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};

export default createInvoiceForClaimGroupCommand;
